var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 17",
    style: {
      enableBackground: "new 0 0 15 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "13.3,7.7 13.3,16 1.5,16 1.5,3.5 8.1,3.5 8.1,2.5 0.5,2.5 0.5,17 14.3,17 14.3,7.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4,14.7l3.4-2.7l4-6.9l-3-1.7L6,10.2L5.4,14.7z M6.9,10.7l3.4-5.9l1.2,0.7l-3.4,5.8l-1.5,1.1L6.9,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,3.1c0.2-0.4,0.3-0.9,0.2-1.3c-0.1-0.4-0.4-0.8-0.8-1c-0.4-0.2-0.9-0.3-1.3-0.2c-0.4,0.1-0.8,0.4-1,0.8       l-1,1.7l3,1.7L14.1,3.1z M11.5,2.7L12,1.8c0.1-0.1,0.2-0.2,0.4-0.3c0.2,0,0.4,0,0.5,0.1l0,0c0.2,0.1,0.3,0.3,0.3,0.4       c0,0.2,0,0.4-0.1,0.5l-0.5,0.8L11.5,2.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPost);
export default __webpack_public_path__ + "static/media/addPost.8837e3062b98bbf794dc2f31d1f25d8f.svg";
export { ForwardRef as ReactComponent };